import angular from 'angular';

let commonModule = angular.module('app.common', [
])
  
.name;

export default commonModule;
